import React, { useEffect, useState } from 'react';
import Banner from '../components/banner';
import Flash_sale from '../components/flash_sale';
import Shipped from '../components/shipped';
import Recently from '../components/recently';
import Wedding from '../components/wedding';
import Designers from '../components/designers';
import Wendell from '../components/wendell';
import Celebrating from '../components/celebrating';
import Handpicked from '../components/handpicked';
import Occasion from '../components/occasion';
import ShopTheLook from '../components/shopthelook';
import NewArrivals from '../components/newarrivals';
import Eid from '../components/Eid';
import Hidden from '../components/hidden';
import Jewel from '../components/jewel';
import Decor from '../components/decor';
import Junior from '../components/junior';
import Bestselling from '../components/Bestselling';
import Celebratory from '../components/Celebratory';
import DesignSpotlight from '../components/designspotlight';
import BestSellingDesigns from '../components/bestsellingdesigns';
import UpcomingEvents from '../components/upcomingevents';
import ShopByColor from '../components/shopbycolor';
import FirstLookBlog from '../components/firstlookblog';
import PearlGloryCollection from '../components/pearlglory';
import Celebriy from '../components/celebriy';
import Stores from '../components/stores';
import Studio from '../components/studio';
import ImageSlider from '../components/imageSlider';
import CategoryImgList from '../components/CategoryImgList';
import { homeshowhideList } from '../services/General-service';
import { TailSpin } from "react-loader-spinner";
import Footer from '../components/footer';
import Loader from "../components/Loader";
import { BrowserView, MobileView } from 'react-device-detect';
import LazyLoad from 'react-lazyload';
function Home() {
  const [showhidebanner, setshowhideBanner] = useState(false);
  const [showhidebestselling, setshowhidebestselling] = useState(false);
  const [showhidemusthave, setshowhidemusthave] = useState(false);
  const [showhideccloset, setshowhideccloset] = useState(false);
  const [showhideddecor, setshowhideddecor] = useState(false);
  const [showhidejunior, setshowhidejunior] = useState(false);
  const [showhidestores, setshowhidestores] = useState(false);
  const [showhidesubbanner, setshowhidesubBanner] = useState(false);
  const [showhidejcabinet, setshowhidejcabinet] = useState(false);
  const [showlastchancetobuy, setshowlastchancetobuy] = useState(false);
  const [showrecentviewed, setshowrecentviewed] = useState(false);
  const [showweddingtale, setshowweddingtale] = useState(false);
  const [showdondis, setshowdondis] = useState(false);
  const [showhiighlightd, setshowhiighlightd] = useState(false);
  const [showwatchshop, setshowwatchshop] = useState(false);
  const [showcelebsaree, setshowcelebsaree] = useState(false);
  const [showsbyocc, setshowsbyocc] = useState(false);
  const [showeidpicks, setshoweidpicks] = useState(false);
  const [showhpdeals, setshowhpdeals] = useState(false);
  const [showwomenj, setshowwomenj] = useState(false);
  const [shownewarrivals, setshownewarrivals] = useState(false);
  const [showdesignspotlight, setshowdesignspotlight] = useState(false);
  const [shownewcollections, setshownewcollections] = useState(false);
  const [showupcomingevents, setshowupcomingevents] = useState(false);
  const [showpearlglory, setshowpearlglory] = useState(false);
  const [showrangbhoomi, setshowrangbhoomi] = useState(false);
  const [showshopthelook, setshowshopthelook] = useState(false);
  const [sectionTitles, setSectionTitles] = useState({});
  const [loading, setLoading] = useState(true);

  const getShowhideList = () => {
    const sectionMap = {
      1: setshowhideBanner,
      2: setshowhidesubBanner,
      3: setshowhideddecor,
      4: setshowhidejunior,
      5: setshowhidestores,
      6: setshowhideccloset,
      7: setshowhidemusthave,
      8: setshowhidebestselling,
      9: setshowhidejcabinet,
      10: setshowlastchancetobuy,
      11: setshowrecentviewed,
      12: setshowweddingtale,
      13: setshowdondis,
      14: setshowhiighlightd,
      15: setshowwatchshop,
      16: setshowcelebsaree,
      17: setshowsbyocc,
      18: setshoweidpicks,
      19: setshowhpdeals,
      20: setshowwomenj,
      21: setshownewarrivals,
      22: setshowdesignspotlight,
      23: setshownewcollections,
      24: setshowupcomingevents,
      25: setshowpearlglory,
      26: setshowrangbhoomi,
      27: setshowshopthelook
    };

    homeshowhideList('')
      .then((data) => {
        // Handle different possible response structures
        const cmsSettingList = data?.data || data || [];

        // Debug: Log the entire response to see what we're getting
        console.log("Home Show/Hide API Response:", data);
        console.log("CMS Setting List:", cmsSettingList);

        const titles = {};

        if (cmsSettingList?.length > 0) {
          cmsSettingList.forEach(dtlist => {
            // Some backends send different fields for show/hide, so normalise them here
            const rawStatus =
              dtlist.status !== undefined && dtlist.status !== null
                ? dtlist.status
                : dtlist.show_hide !== undefined && dtlist.show_hide !== null
                ? dtlist.show_hide
                : dtlist.show_hide_status !== undefined && dtlist.show_hide_status !== null
                ? dtlist.show_hide_status
                : dtlist.show;

            const statusStr = rawStatus !== undefined && rawStatus !== null
              ? String(rawStatus).trim().toUpperCase()
              : '';

            // Treat ONLY these values as VISIBLE, everything else hidden
            const isVisible =
              statusStr === '1' ||
              statusStr === 'TRUE' ||
              statusStr === 'SHOW' ||
              rawStatus === 1 ||
              rawStatus === true;

            const isHidden = !isVisible;

            const sectionId = Number(dtlist.id);
            const displayTitle = String(dtlist.name || '').trim();
            if (sectionId && displayTitle) {
              titles[sectionId] = displayTitle;
            }

            console.log(`Processing home CMS: id="${sectionId}", name="${displayTitle}", rawStatus="${rawStatus}" (type: ${typeof rawStatus}), isVisible=${isVisible}, isHidden=${isHidden}`);

            if (sectionMap[sectionId]) {
              if (isHidden) {
                console.log(`Hiding ${displayTitle}`);
                sectionMap[sectionId](false);
              } else {
                console.log(`Showing ${displayTitle}`);
                sectionMap[sectionId](true);
              }
            }
          });
        } else {
          console.warn("CMS Setting List is empty or not an array:", cmsSettingList);
          // If API fails or returns empty, hide all sections to avoid accidentally showing hidden CMS blocks.
          Object.values(sectionMap).forEach(setter => setter(false));
        }

        setSectionTitles(titles);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching home show hide list:", error);
        // On error also hide all sections so nothing hidden in CMS accidentally shows.
        Object.values(sectionMap).forEach(setter => setter(false));
        setLoading(false);
      });
  };

  useEffect(() => {
    getShowhideList();

  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    loading ? (
      <Loader />
    ) : (
      <>
        <div>
          <div className='BreakPointContainer AppContent'>
            <div className='HomeSection'>
              <div className="list">
                <LazyLoad height={200} >
                  <CategoryImgList />
                </LazyLoad>
                <MobileView>
                  <Banner showBanner={showhidebanner} />
                  <LazyLoad height={200} offset={[-200, 0]}>
                    <Recently showrecentviewed={showrecentviewed} sectionTitle={sectionTitles[11]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-200, 0]}>
                    <Flash_sale showsubBanner={showhidesubbanner} />
                  </LazyLoad>
                  <LazyLoad height={320} offset={[-200, 0]}>
                    <ImageSlider showwatchshop={showwatchshop} sectionTitle={sectionTitles[15]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-200, 0]}>
                    <NewArrivals shownewarrivals={shownewarrivals} sectionTitle={sectionTitles[21]} />
                    <Celebratory showmusthave={showhidemusthave} sectionTitle={sectionTitles[7]} />
                    <DesignSpotlight
                      showdesignspotlight={showdesignspotlight}
                      sectionTitle={sectionTitles[22]}
                      shownewcollections={shownewcollections}
                      collectionsTitle={sectionTitles[23]}
                    />
                    <BestSellingDesigns showbestselling={showhidebestselling} sectionTitle={sectionTitles[8]} />
                    <Handpicked showhpdeals={showhpdeals} sectionTitle={sectionTitles[19]} />
                    <UpcomingEvents showupcomingevents={showupcomingevents} sectionTitle={sectionTitles[24]} />
                    <PearlGloryCollection showpearlglory={showpearlglory} sectionTitle={sectionTitles[25]} />
                    <ShopByColor showrangbhoomi={showrangbhoomi} sectionTitle={sectionTitles[26]} />
                    <Shipped showlastchancetobuy={showlastchancetobuy} sectionTitle={sectionTitles[10]} />
                    <Wedding showweddingtale={showweddingtale} sectionTitle={sectionTitles[12]} />
                  </LazyLoad>
                </MobileView>
                <BrowserView>
                  <LazyLoad height={200}>
                    <Banner showBanner={showhidebanner} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <Recently showrecentviewed={showrecentviewed} sectionTitle={sectionTitles[11]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <Flash_sale showsubBanner={showhidesubbanner} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <ImageSlider showwatchshop={showwatchshop} sectionTitle={sectionTitles[15]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <NewArrivals shownewarrivals={shownewarrivals} sectionTitle={sectionTitles[21]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <Celebratory showmusthave={showhidemusthave} sectionTitle={sectionTitles[7]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <DesignSpotlight
                      showdesignspotlight={showdesignspotlight}
                      sectionTitle={sectionTitles[22]}
                      shownewcollections={shownewcollections}
                      collectionsTitle={sectionTitles[23]}
                    />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <BestSellingDesigns showbestselling={showhidebestselling} sectionTitle={sectionTitles[8]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <Handpicked showhpdeals={showhpdeals} sectionTitle={sectionTitles[19]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <UpcomingEvents showupcomingevents={showupcomingevents} sectionTitle={sectionTitles[24]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <PearlGloryCollection showpearlglory={showpearlglory} sectionTitle={sectionTitles[25]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-250, 0]}>
                    <ShopByColor showrangbhoomi={showrangbhoomi} sectionTitle={sectionTitles[26]} />
                  </LazyLoad>
                  <LazyLoad height={200} offset={[-50, 0]}>
                    <Shipped showlastchancetobuy={showlastchancetobuy} sectionTitle={sectionTitles[10]} />
                  </LazyLoad>
                  <LazyLoad height={200}>
                      <Wedding showweddingtale={showweddingtale} sectionTitle={sectionTitles[12]} />
                    </LazyLoad>                  
                </BrowserView>

                <LazyLoad height={200}>
                  <Designers showdondis={showdondis} sectionTitle={sectionTitles[13]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Wendell showhiighlightd={showhiighlightd} sectionTitle={sectionTitles[14]} />
                </LazyLoad>
                <LazyLoad height={320} offset={[-100, 0]}>
                  <ShopTheLook showshopthelook={showshopthelook} sectionTitle={sectionTitles[27]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Celebrating showcelebsaree={showcelebsaree} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Celebriy ccloset={showhideccloset} sectionTitle={sectionTitles[6]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Occasion showsbyocc={showsbyocc} sectionTitle={sectionTitles[17]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Eid showeidpicks={showeidpicks} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Jewel showjcabinet={showhidejcabinet} sectionTitle={sectionTitles[9]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Decor showddecor={showhideddecor} sectionTitle={sectionTitles[3]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Junior showjunior={showhidejunior} sectionTitle={sectionTitles[4]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  <Hidden showwomenj={showwomenj} sectionTitle={sectionTitles[20]} />
                </LazyLoad>
                <LazyLoad height={200}>
                  {/* <Gentlemen/> */}
                  {/* <Bestselling showbestselling={showhidebestselling} /> */}
                </LazyLoad>
                <LazyLoad height={200}>
                  <Stores showstores={showhidestores} />
                </LazyLoad>
                <LazyLoad height={200} offset={[-100, 0]}>
                  <Studio />
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
        <LazyLoad height={200} offset={[-100, 0]}>
          <FirstLookBlog />
        </LazyLoad>
        <LazyLoad height={200}>
          <Footer />
        </LazyLoad>
      </>

    )
  )
}

export default Home